import { HOMEPAGE_DATA_LOADED } from '../actions/CompoundFetchActions';
import Raffle from '../models/Raffle';
import CarouselReducer from './homepage/CarouselReducer';
import reduceReducers from 'reduce-reducers';
import FetchReducer from './homepage/FetchReducer';
import DateService from '../services/DateService';

const initialState = {
	activeOrComingSoonRaffles: {
		items: [],
		fetching: false,
		moreAvailable: false,
		page: 1
	},
	closedRaffles: {
		items: [],
		fetching: false,
		moreAvailable: false,
		page: 1
	},
	carouselRaffles: {
		items: [],
		activeIndex: 0
	},
	loaded: false,
	lastReload: null
};

export default class HomepageReducer {

	/**
	 * @param {object} state
	 * @param {object} action
	 */
	static reduce(state = initialState, action) {
		// Use helper reducers to split some action handling into multiple classes
		state = HomepageReducer.reduceChainedReducers(state, action);
		switch (action.type) {
			// If initial data was loaded, we want to load our currencies
			case HOMEPAGE_DATA_LOADED:
				return HomepageReducer.normalize({
					...state,
					activeOrComingSoonRaffles: {
						items: action.activeOrComingSoonRaffles.documents,
						fetching: false,
						moreAvailable: action.activeOrComingSoonRaffles.documents.length < action.activeOrComingSoonRaffles.total,
						page: 1
					},
					closedRaffles: {
						items: action.closedRaffles.documents,
						fetching: false,
						moreAvailable: action.closedRaffles.documents.length < action.closedRaffles.total,
						page: 1
					},
					carouselRaffles: {
						items: action.carouselRaffles.documents,
						activeIndex: 0
					},
					loaded: true,
					lastReload: DateService.getCurrentDateInSeconds()
				});
			default:
				return state;
		}
	}

	/**
	 * @param {object} state
	 * @return {*}
	 */
	static normalize = (state) => {
		const activeOrComingSoonRaffles = {
			...state.activeOrComingSoonRaffles,
			items: state.activeOrComingSoonRaffles.items.map((raffle) => Raffle.normalize(raffle))
		};

		const closedRaffles = {
			...state.closedRaffles,
			items: state.closedRaffles.items.map((raffle) => Raffle.normalize(raffle))
		};

		const carouselRaffles = {
			...state.carouselRaffles,
			items: state.carouselRaffles.items.map((raffle) => Raffle.normalize(raffle))
		};

		return { ...state, activeOrComingSoonRaffles, closedRaffles, carouselRaffles };
	};
}

HomepageReducer.reduceChainedReducers = reduceReducers(
	CarouselReducer.reduce,
	FetchReducer.reduce,
);


// WEBPACK FOOTER //
// ./reducers/HomepageReducer.js